module.exports = require("./es-NI");